export const getSubscriptionRemainingDays = (purchasedAt, durationDays) => {
  const duration = parseInt(durationDays, 10);
  if (!purchasedAt || isNaN(duration) || duration <= 0) {
    return null;
  }

  const expirationDate = new Date(purchasedAt);
  expirationDate.setDate(expirationDate.getDate() + duration);

  const today = new Date();
  return Math.max(
    0,
    Math.ceil((expirationDate - today) / (1000 * 60 * 60 * 24))
  );
};

export const isSubscriptionActive = (purchasedAt, durationDays) => {
  const remainingDays = getSubscriptionRemainingDays(purchasedAt, durationDays);
  return remainingDays !== null && remainingDays > 0;
};
